import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class TimesheetsPendentesStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    onExportExcel = () => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadTimesheetsPendentesExcel().then(response => {
            fileDownload(response.data, "TimesheetsPendentes.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }
}
